export const DEALERSHIP_UPDATE = 'DEALERSHIP_UPDATE';
export const OPEN_DEAL = 'OPEN_DEAL';
export const SAVE_DEAL_REQUEST = 'SAVE_DEAL_REQUEST';
export const SAVE_DEAL_SUCCESS = 'SAVE_DEAL_SUCCESS';
export const SAVE_DEAL_FAILURE = 'SAVE_DEAL_FAILURE';
export const COMMON_CONSUMER_UPDATE = 'COMMON_CONSUMER_UPDATE';
export const COMMON_CONSUMER_UPDATE_VALIDATION_STATE = 'COMMON_CONSUMER_UPDATE_VALIDATION_STATE';
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';
export const TOGGLE_CHANGE_VEHICLE_EDIT_VIEW = 'TOGGLE_CHANGE_VEHICLE_EDIT_VIEW';
export const SWITCH_VEHICLE = 'SWITCH_VEHICLE';
export const SYNC_CONSUMER_DATA = 'SYNC_CONSUMER_DATA';
export const FETCH_DEAL_HISTORY_SUCCESS = 'FETCH_DEAL_HISTORY_SUCCESS';
export const SWITCH_VEHICLE_HIDE_LOADER = 'SWITCH_VEHICLE_HIDE_LOADER';
export const RESET_OPEN_DEAL_STATE = 'RESET_OPEN_DEAL_STATE';
